import React, {useState} from "react";
import Box from "@mui/material/Box";
import CustomTextField from "../../../../../components/customMUIComponents/CustomTextField";
import {MenuItem} from "@mui/material";
import {
    ProductDTO
} from "../../../../../components/societyAdmin/societyAdminArticles/societyAdminArticlesList/SocietyAdminArticlesList";
import useFormatNumber from "../../../../../hooks/useFormatNumber";
import {CategoryDTO} from "../../../../../context/SocietyProvider";
import {getListAllCategories} from "../../articlesUtils";
import useSociety from "../../../../../hooks/useSociety";

export interface ArticleDetailsDefinitionProps {
    product?: ProductDTO,
}

const ArticleDetailsDefinition = ({product}: ArticleDetailsDefinitionProps) => {
    const {society} = useSociety();

    const allCategories = getListAllCategories(society.categories!);

    const {formatCentsToPrice} = useFormatNumber();

    const [title, setTitle] = useState<string>(product?.name || '');
    const [description, setDescription] = useState<string>(product?.description || '');
    const [price, setPrice] = useState<string>((product?.price && formatCentsToPrice(product.price)) || '');
    const [isStockDefined, setIsStockDefined] = useState<boolean | undefined>(product ? product.stockDefined : undefined);
    const [stock, setStock] = useState<string>((product?.stock && product.stock.toString()) || '');
    const [productCategory, setProductCategory] = useState<number>(product?.category ? product.category.id : -1);

    const handleSetPrice = (value: string) => {
        const dec = value.indexOf(".");
        const tooLong = value.length > dec + 3;
        const invalidNum = isNaN(parseFloat(value));

        if ((dec >= 0 && tooLong) || invalidNum) {
            setPrice(value.slice(0, -1));
            return;
        }
        setPrice(value);
    }

    return (
        <Box>

            <CustomTextField
                value={title}
                label="Titre"
                mb={4}
                type="text"
                required
                setField={setTitle}
                variant="outlined"
            />

            <CustomTextField
                value={description}
                label="Description"
                mb={4}
                type="text"
                setField={setDescription}
                variant="outlined"
                multiline={true}
                rows={4}
            />

            <CustomTextField
                value={price}
                label="Prix"
                mb={4}
                type="number"
                step={"0.01"}
                min={0.01}
                required
                setField={handleSetPrice}
                variant="outlined"
                endAdornment={"CHF"}
            />

            <CustomTextField
                variant={"outlined"}
                value={isStockDefined === undefined ? "" : isStockDefined ? "yes" : "no"}
                label={"Définir un stock"}
                setField={(fieldValue) => setIsStockDefined(fieldValue === "yes")}
                select
                selectOptions={[
                    <MenuItem key="yes" value={'yes'}>Oui</MenuItem>,
                    <MenuItem key="no" value={'no'}>Non</MenuItem>
                ]}
                mb={4}
                textAlign={"left"}
                required
            />

            {isStockDefined && (
                <CustomTextField
                    value={stock}
                    label="Nombre de pièces en stock"
                    mb={4}
                    type="number"
                    step={"1"}
                    min={0}
                    required
                    setField={setStock}
                    variant="outlined"
                />
            )}

            <CustomTextField
                variant={"outlined"}
                value={productCategory}
                label={"Modifier la catégorie"}
                setField={setProductCategory}
                select
                selectOptions={
                    [
                        <MenuItem key={'uncategorized'} value={-1}>{'Non catégorisé'}</MenuItem>,
                        ...allCategories.map((category: CategoryDTO) => {
                            return (<MenuItem key={category.name}
                                              value={category.id}>{category.name}</MenuItem>)
                        })
                    ]
                }
                mb={4}
                textAlign={"left"}
                required
            />

        </Box>
    );
}

export default ArticleDetailsDefinition